import axios from "axios";
export default {
	data() {
		return {
			strutturaJsonData: {},
			strutturaOptions: [],
			strutturePathResources: "/strutture",
		};
	},
	methods: {
		setDestinationData() { },
		struttureLoadData() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.strutturePathResources;
			axios.get(link)
				.then((response) => {
					this.strutturaOptions = response.data.data;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		strutturaLoadDataById(idStruttura, responseCallback = null) {
			let me = this;
			console.log("ho capito");

			let link = process.env.VUE_APP_PATH_API + me.strutturePathResources + "/" + idStruttura;
			axios.get(link)
				.then((response) => {
					this.strutturaJsonData = response.data.data;
					this.strutturaIbanOptions = this.strutturaJsonData.listaIban;
					if (responseCallback) responseCallback(this.strutturaJsonData);
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		strutturaLoadDataByCodice(codiceStruttura) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.strutturePathResources + "/codice/" + codiceStruttura;
			axios.get(link)
				.then((response) => {
					this.strutturaJsonData = response.data.data;
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		setDatiStrutturaJsonData() { },
	},
};
